import scenario from "planets/axion/axion-scenario.svg"
import flag from "planets/axion/axion-high-flag.svg"
import { stone0, stone1, stone2, stone3, stone4, stone5, stone6 } from "planets/axion/stone"

export default {
  stones: [stone0, stone1, stone2, stone3, stone4, stone5, stone6],
  scenario: scenario,
  flag: flag,
  gradient: "linear-gradient(180deg,#38003e 0%,#6800bf 100%)",
  paddingTop: "20px"
}
